<div>
  <!-- Admin User Form -->
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <!-- Two Column Layout -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
      <!-- Left Card: User Data -->
      <p-card>
        <ng-template pTemplate="header">
          <div class="p-4 pb-0">
            <h2 class="text-heading-md mb-1">{{ 'adminUserEdit.userDataTitle' | translate }}</h2>
            <p class="text-body-sm text-secondary">
              {{ 'adminUserEdit.userDataDescription' | translate }}
            </p>
          </div>
        </ng-template>

        <div class="flex flex-col gap-6">
          <!-- Email Field -->
          <div class="flex flex-col gap-2">
            <label for="email" class="text-label-md">{{ 'adminUserEdit.email' | translate }}</label>
            @if (loading()) {
            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
            <input
              id="email"
              type="email"
              pInputText
              formControlName="email"
              [placeholder]="'adminUserEdit.emailPlaceholder' | translate"
              fluid
              autocomplete="new-password"
              [attr.data-form-type]="'other'"
            />
            @if (userForm.get('email')?.invalid && userForm.get('email')?.touched) {
            <p-message severity="error">
              {{ getEmailErrorMessage() }}
            </p-message>
            } }
          </div>

          <!-- Username Field -->
          <div class="flex flex-col gap-2">
            <label for="username" class="text-label-md">{{
              'adminUserEdit.username' | translate
            }}</label>
            @if (loading()) {
            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
            <input
              id="username"
              type="text"
              pInputText
              formControlName="username"
              [placeholder]="'adminUserEdit.usernamePlaceholder' | translate"
              fluid
              autocomplete="new-password"
              [attr.data-form-type]="'other'"
              readonly
              (focus)="$any($event.target).removeAttribute('readonly')"
            />
            @if (userForm.get('username')?.invalid && userForm.get('username')?.touched) {
            <p-message severity="error">
              {{ getUsernameErrorMessage() }}
            </p-message>
            } }
          </div>

          <!-- Password Field -->
          <div class="flex flex-col gap-2">
            <label for="password" class="text-label-md">{{
              'adminUserEdit.password' | translate
            }}</label>
            @if (loading()) {
            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
            <p-password
              formControlName="password"
              [placeholder]="'adminUserEdit.passwordPlaceholder' | translate"
              [toggleMask]="true"
              [feedback]="false"
              fluid
              [attr.autocomplete]="'new-password'"
            />
            @if (userForm.get('password')?.invalid && userForm.get('password')?.touched) {
            <p-message severity="error">
              {{ getPasswordErrorMessage() }}
            </p-message>
            } }
          </div>

          <!-- Password Confirm Field -->
          <div class="flex flex-col gap-2">
            <label for="passwordConfirm" class="text-label-md">{{
              'adminUserEdit.passwordConfirm' | translate
            }}</label>
            @if (loading()) {
            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
            <p-password
              id="passwordConfirm"
              formControlName="passwordConfirm"
              [placeholder]="'adminUserEdit.passwordConfirmPlaceholder' | translate"
              [toggleMask]="true"
              [feedback]="false"
              fluid
              [attr.autocomplete]="'new-password'"
            />
            @if ((userForm.get('passwordConfirm')?.invalid &&
            userForm.get('passwordConfirm')?.touched) || (userForm.errors?.['passwordMismatch'] &&
            userForm.get('passwordConfirm')?.touched)) {
            <p-message severity="error">
              {{ getPasswordConfirmErrorMessage() }}
            </p-message>
            } }
          </div>
        </div>
      </p-card>

      <!-- Right Card: Permissions -->
      <p-card>
        <ng-template pTemplate="header">
          <div class="p-4 pb-0">
            <h2 class="text-heading-md mb-1">{{ 'adminUserEdit.permissions' | translate }}</h2>
            <p class="text-body-sm text-secondary">
              {{ 'adminUserEdit.permissionsDescription' | translate }}
            </p>
          </div>
        </ng-template>

        <div class="flex flex-col gap-4">
          @if (loading()) {
          <!-- Loading skeleton -->
          <div class="flex flex-col gap-4">
            <p-skeleton width="100%" height="6rem"></p-skeleton>
            <p-skeleton width="100%" height="6rem"></p-skeleton>
            <p-skeleton width="100%" height="6rem"></p-skeleton>
          </div>
          } @else {
          <!-- Permissions by category -->
          <div class="flex flex-col gap-4">
            @for (category of getCategories(); track category) {
            <p-panel [header]="category" [toggleable]="true" [collapsed]="false">
              <div class="flex flex-col gap-3">
                @for (permission of getPermissionsForCategory(category); track permission.value) {
                <div class="flex items-center gap-3">
                  <p-checkbox
                    [binary]="true"
                    [inputId]="'permission-' + permission.value"
                    [ngModel]="isPermissionSelected(permission.value || '')"
                    (ngModelChange)="togglePermission(permission.value || '', $event)"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    [for]="'permission-' + permission.value"
                    class="flex flex-col gap-1 cursor-pointer flex-1"
                  >
                    <span class="text-label-md">{{ permission.label }}</span>
                    <span class="text-body-sm text-secondary">{{ permission.description }}</span>
                  </label>
                </div>
                }
              </div>
            </p-panel>
            }
          </div>
          }
        </div>
      </p-card>
    </div>
  </form>
</div>
